import { render, staticRenderFns } from "./AdminEditPwd.vue?vue&type=template&id=29cd3628&"
import script from "./AdminEditPwd.vue?vue&type=script&lang=js&"
export * from "./AdminEditPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports